/**
 *
 * @module subscriptionClientConfiguration
 *
 */

import ServiceClientConfiguration from './../configuration/serviceClientConfiguration';

/**
 *
 * @class SubscriptionClientConfiguration
 * @extends {ServiceClientConfiguration}
 * @desc Provides configuration information used by the SubscriptionClient.
 *
 */
export default class SubscriptionClientConfiguration extends ServiceClientConfiguration {}



// WEBPACK FOOTER //
// ./src/services/subscription/subscriptionClientConfiguration.js